import {useMutation, useQueryClient} from '@tanstack/react-query'
import {login as loginApi, switchRole as switchRoleApi, logout as logoutApi} from '@/services/apiAuth'

import {useNavigate} from 'react-router-dom'
import {closeAllTabs, setUser, signOutSuccess, useAppDispatch} from '@/store'
import {Notification, toast} from '@/components/ui'
import { sessionData, setSessionData } from '@/features/context/SessionContext'

export default function useAuth() {
    const dispatch = useAppDispatch()
    let isLoading = false
    let navigate = useNavigate()

    const queryClient = useQueryClient()

    const {mutate: login} = useMutation({
        mutationFn: ({step, mobileNumber, nationalCode, code, role, name, password, forgot = false, app}) => loginApi({
            step,
            mobileNumber,
            nationalCode,
            code,
            role,
            name,
            password,
            forgot,
            app
        })
    })

    const {mutate: switchRole} = useMutation({
        mutationFn: ({role}) => switchRoleApi({
           role
        })
    })

    const {mutate: logout} = useMutation({
        mutationFn: () => {
            if (sessionData('oldToken')) {
                setSessionData('token', sessionData('oldToken'))
                setSessionData('oldToken', null)
                window.location.reload()
                return
            }

            logoutApi({}).finally(()=> {
                dispatch(signOutSuccess())
                dispatch(closeAllTabs())
                dispatch(setUser(null))
                // setSessionId(null)
                queryClient.removeQueries()
                setTimeout(() => {
                    navigate('/login', { replace: true })
                }, 500)
            });
        },
        onSettled: (response) => {
            if (response.success) {
                response.message && toast.push(<Notification type="success" title={response.message}/>)
            } else
                toast.push(<Notification type="danger" title={response.message}/>)
        }
    })


    return {isLoading, login, switchRole, logout}
}

